import React from "react";
import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";

type SalesRepType =
  | "salesRepresentative"
  | "salesRepresentative2"
  | "salesBusinessDeveloper"
  | "directSalesLead"
  | "teamManager"
  | "customerSuccessManager"
  | "partnerManager";

export default function SalesRepIcon({
  type,
  label,
}: {
  type: SalesRepType;
  label: string;
}) {
  const getBackgroundColor = () => {
    switch (type) {
      case "salesBusinessDeveloper":
        return "rgb(26, 162, 26,0.4)"; // Green for BDR
      case "directSalesLead":
        return "rgb(162, 26, 162,0.4)"; // Purple for Direct Sales Lead
      case "teamManager":
        return "rgb(162, 26, 82,0.4)"; // Pink for Team Manager
      case "customerSuccessManager":
        return "rgb(162, 82, 26,0.4)"; // Orange for CSM
      case "partnerManager":
        return "rgb(26, 139, 162,0.4)"; // Teal for Partner Manager
      default:
        return "rgb(26, 26, 162,0.4)"; // Blue for Account Managers
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
      <Avatar
        shape="circle"
        size="small"
        style={{
          display: "inline-block",
          backgroundColor: getBackgroundColor(),
          marginRight: "8px",
        }}
        icon={<UserOutlined />}
      ></Avatar>
      <span style={{ display: "inline-block" }}>{label}</span>
    </div>
  );
}
